"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ecardUrl = exports.profileUrl = exports.cmxUrl = exports.idURL = void 0;

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.string.replace.js");

var env = window.location.hostname.toLowerCase().split('.').find(function (chunk) {
  return ['localhost', 'qa', 'pprd'].indexOf(chunk) >= 0;
});

function getURL(url) {
  if (env === 'localhost') {
    env = 'qa';
  }

  return url.toLowerCase().replace('(env.)', env ? env + '.' : '');
}

var idURL = getURL('https://(env.)api.biw.cloud/v1/id');
exports.idURL = idURL;
var cmxUrl = getURL('https://(env.)api.biw.cloud/v2/cmx');
exports.cmxUrl = cmxUrl;
var profileUrl = getURL('https://(env.)api.biw.cloud/v1/profile');
exports.profileUrl = profileUrl;
var ecardUrl = getURL('https://(env.)api.biw.cloud/v1/ecard-wrapper');
exports.ecardUrl = ecardUrl;
//# sourceMappingURL=endpoints.js.map